import { Camera } from 'lucide-react';

const STATE_NAMES = {
  VIC: 'Victoria', SA: 'South Australia', NSW: 'New South Wales',
  QLD: 'Queensland', WA: 'Western Australia', TAS: 'Tasmania',
  ACT: 'ACT', NT: 'Northern Territory',
};

/**
 * Branded "photos coming soon" placeholder for listings whose portal
 * feed hasn't served images yet (e.g. newly onboarded VIC/Turnkey
 * packages). Intentional-looking fill instead of a bare grey icon.
 */
export const PhotoComingSoon = ({ state, className = '' }) => {
  const label = STATE_NAMES[state] || null;
  return (
    <div
      className={`w-full h-full flex flex-col items-center justify-center text-center px-4 bg-gradient-to-br from-[#e9f1ff] via-[#f3f7ff] to-[#eef1f6] ${className}`}
      data-testid="package-photo-coming-soon"
    >
      <div className="w-12 h-12 rounded-full bg-white/85 ring-1 ring-[#1d8efe]/20 flex items-center justify-center mb-3 shadow-sm">
        <Camera className="w-5 h-5 text-[#1d8efe]" />
      </div>
      <span className="text-[13px] font-semibold text-[#1d1d1f] tracking-tight">Photos coming soon</span>
      {label && <span className="text-[11.5px] text-[#86868b] mt-1">{label}</span>}
    </div>
  );
};

export default PhotoComingSoon;
